import { render, staticRenderFns } from "./safe.vue?vue&type=template&id=490a6d48"
import script from "./safe.vue?vue&type=script&lang=js"
export * from "./safe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports